import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/v2_live/icomm/app/(dashboard)/contacts/page.tsx");
